module.exports = __webpack_public_path__ + "static/media/item_33_6.0e542242.png";